export default __webpack_public_path__ + "static/media/storydots-white-logo.6842e982.svg";